var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCapacitor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2500,
    preserveAspectRatio: "xMidYMid",
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256.005",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.863 54.115L.31 93.716l60.995 61.179L0 216.385l39.428 39.62 61.43-61.508 61.097 61.068 39.552-39.602z",
    fill: "#53b9ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140.517 154.896l-39.658 39.601 61.097 61.069 39.552-39.602z",
    fill: "#119eff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.517 154.896l-39.658 39.601 15.267 15.182z",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M194.57 100.985L256 39.478 216.43 0 155.02 61.384 93.917.31 54.365 39.913 216.01 201.761l39.552-39.602z",
    fill: "#53b9ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115.36 100.987l39.659-39.602L93.917.313 54.365 39.914z",
    fill: "#119eff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.359 100.985l39.659-39.601-15.27-15.186z",
    fillOpacity: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapacitor);
export default __webpack_public_path__ + "static/media/capacitor.422be4681bd6ecab944a8a5c8156d3c9.svg";
export { ForwardRef as ReactComponent };